import mapActions from "actions/map";
import modalActions from "actions/modal";
import { FormTemplate } from "components/modal/templates";
import React from "react";
import { connect } from "react-redux";
import { apply } from "sources/books/itemChangePoints";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateItemChangePointModal extends FormTemplate {
    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} renderGeopicker={this.renderGeopicker} />;
    };
}

const ConfiguredModal = (props) => (
    <CreateItemChangePointModal {...props} config={config} initialState={initialState} />
);

const customDispatch = (dispatch) => {
    return {
        addModal: (params) => dispatch(modalActions.add(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const mapState = (_state) => ({});
const customConnect = (Component) => connect(mapState, customDispatch)(Component);

export default customConnect(ConfiguredModal);
